module.exports = __webpack_public_path__ + "static/media/alto.fa0bc4d1.png";